// Components==============
import React, { createContext, useState } from 'react';
// =========================

type GlobalContextTypes = {
    selected: selectedOptions;
    setSelected: React.Dispatch<React.SetStateAction<selectedOptions>>;
    menuY: number;
    setMenuY: React.Dispatch<React.SetStateAction<number>>;
    keyboardIsOpen: boolean;
    setKeyboardIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    keyboardInput: string[];
    setKeyboardInput: React.Dispatch<React.SetStateAction<string[]>>;
    toggleState: boolean;
    togglePlay: () => void;
    logbookAuthenticated: boolean;
    setLogbookAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalContext = createContext({} as GlobalContextTypes);

// All values within this context will be persisted on Route change

export default function GlobalContextWrapper({
    children,
}: {
    children: React.ReactNode;
}) {
    const [selected, setSelected] = useState<selectedOptions>('initial');
    const [menuY, setMenuY] = useState(0);
    const [keyboardIsOpen, setKeyboardIsOpen] = useState(false);
    const [keyboardInput, setKeyboardInput] = useState<string[]>([]);
    const [toggleState, setTogglePlayState] = useState(false);
    const [logbookAuthenticated, setLogbookAuthenticated] = useState(false);

    function togglePlay() {
        setTogglePlayState((prev) => !prev);
    }

    return (
        <GlobalContext.Provider
            value={{
                selected,
                setSelected,
                menuY,
                setMenuY,
                keyboardIsOpen,
                setKeyboardIsOpen,
                keyboardInput,
                setKeyboardInput,
                toggleState,
                togglePlay,
                logbookAuthenticated,
                setLogbookAuthenticated,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
}
